import { render, staticRenderFns } from "./PcApiLookupDataSelectReskinned.vue?vue&type=template&id=2221af0f"
import script from "./PcApiLookupDataSelectReskinned.vue?vue&type=script&lang=js"
export * from "./PcApiLookupDataSelectReskinned.vue?vue&type=script&lang=js"
import style0 from "./PcApiLookupDataSelectReskinned.vue?vue&type=style&index=0&id=2221af0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItemSubtitle,VListItemTitle,VSelect})
